/**
 * Columnas "livianas" de `client_website_config`: todo menos
 * `elements_structure`, el JSON comprimido del builder, que puede pesar de
 * 34 KB a 13 MB según el tenant y se baja aparte, en segundo plano.
 *
 * Las usan el servidor (layout) y el navegador (ClientProvider): tienen que
 * ser las mismas para que el store reciba exactamente la misma fila venga de
 * donde venga.
 */
export const WEBSITE_CONFIG_LIGHT_COLS =
  'id, client_id, theme, content, why_us_items, media, integrations, ' +
  'is_enabled, sections, typography, home_html, home_css, color_scheme, ' +
  'translations, created_at, updated_at';

/**
 * Columnas de `clients` que usa el sitio. NO volver a `*`: la fila completa
 * viaja serializada en el HTML de cada página (layout → initialClient) y trae
 * datos internos de la automotora (plan, suscripción, reglas de leads…).
 * La base solo le deja leer a anon estas columnas + website_suspended_at (la pide
 * el middleware): una columna nueva que el sitio necesite hay que sumarla ACÁ y
 * al GRANT de anon en goautos-admin.
 * `contact` llega desde `public_contact` (solo email, phone y address). Las listas
 * internas de correos ya no viajan; los destinatarios los resuelve la edge send-email.
 */
export const CLIENT_PUBLIC_COLS =
  'id, name, domain, custom_domain, logo, logo_dark, favicon, theme, seo, ' +
  'contact:public_contact, location, has_demo, has_dark_mode, has_language_selector, ' +
  'default_language, currency, country, card_title_field, ventas_exentas_iva, ' +
  'web_vehicle_order, web_price_mode';

/**
 * Columnas de `dealerships` que usa el sitio. NO volver a `*`: anon solo puede
 * leer estas (pentest 30-oct, GRANT en goautos-admin 20270111130000) y un `*`
 * da 401 y deja al sitio sin sucursales. Afuera quedan el reparto de leads, las
 * reglas de agenda y el `opening_hours` legacy (el horario va por
 * `fn_dealership_public_hours`). Una columna nueva hay que sumarla ACÁ y al GRANT.
 */
export const DEALERSHIP_PUBLIC_COLS =
  'id, client_id, name, address, phone, phones, email, emails, location, timezone, ' +
  'appointment_comms';

/** El select completo del tenant: la fila de `clients` con sucursales y config liviana. */
export const TENANT_ROW_SELECT = `${CLIENT_PUBLIC_COLS}, dealerships(${DEALERSHIP_PUBLIC_COLS}), client_website_config(${WEBSITE_CONFIG_LIGHT_COLS})`;
